module.exports = __webpack_public_path__ + "media/images/ico-buy-243b8587.png";